import {
  Button,
  minValue,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  TextInput,
  useNotify,
  useRefresh,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import { Grid } from "@mui/material";

import { Sync } from "@mui/icons-material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";

const ChangeFaculty = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSent = async data => {
    const payload = {
      newSpecialityId: data.newSpecialityId,
      newStudyGroup: data.newStudyGroup,
      orderNumber: data.orderNumber,
      orderDate: data.orderDate,
      note: data.note,
    };
    await dataProvider.customRequest(studentRequests.transferStudentFaculty(record.id), payload, "PUT");
    refresh();
    notify("Успешна редакция на факултет", { type: "success" });
  };

  return (
    <FormModal
      titleContent="Смяна на факултет"
      onConfirm={handleSent}
      triggerButton={
        <Button
          label="Смяна на факултет"
          variant="contained"
          startIcon={<Sync />}
        />
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <ReferenceInput
            source="newSpecialityId"
            reference={administrationRequests.getSpecialitiesSelect()}
            filter={{
              GroupId: record.specialityGroupId || null,
            }}
          >
            <SelectInput
              label="Специалност"
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            onWheel={e => e.target.blur()}
            onKeyDown={e => {
              if (e.key.length === 1 && !/^\d$/.test(e.key)) {
                e.preventDefault();
              }
            }}
            label="Учебна група"
            source="newStudyGroup"
            validate={[required(), minValue(0, "Минималната стойност е 0")]}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            onWheel={e => e.target.blur()}
            label="Номер на заповед за прехвърляне"
            source="orderNumber"
            validate={required()}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={6}
          sx={{ width: "min-content", margin: "auto" }}
        >
          <CustomDateInput
            label="Дата на заповед за прехвърляне"
            source="orderDate"
            validate={required()}
            noTime
            required={true}
          />
        </Grid>
        <TextInput
          source="note"
          label="Бележка"
          sx={settings.style.textAria}
          variant="outlined"
          fullWidth
          multiline
        />
      </Grid>
    </FormModal>
  );
};

export default ChangeFaculty;
